import configEnv from "@/enums/configEnv";

const langs = {
  methods: {
    getLangMenu(availableLangs) {
      return availableLangs.map((lang) => ({
        title: lang.charAt(0).toUpperCase() + lang.slice(1),
        lang,
        icon: `${configEnv.wpApiServer}/wp-content/plugins/wp-multilang/flags/${lang}.png`,
      }));
    }
  }
}

export default langs;
